export enum EPlatformNames {
  twitch = 'twitch',
  youtube = 'youtube',
  tiktok = 'tiktok',
  kick = 'kick',
}

export enum EPlatformReadableNames {
  twitch = 'Twitch',
  youtube = 'YouTube',
  tiktok = 'TikTok',
  kick = 'Kick',
}

export interface IConnectedAccount {
  link?: string;
  type: EPlatformNames;
  name: string;
  is_destination: boolean;
  is_connected: boolean;
}
